import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { AccountMarketplaceService, AccountSelectionService, isReadOnlyAccess } from "@front/m19-services";
import { IButtonDirective, IIconComponent, ToasterService } from "@front/m19-ui";
import { finalize, take } from "rxjs";

@Component({
  selector: "app-renew-advertising-access-button",
  imports: [IButtonDirective, IIconComponent],
  template: `
    @if (!isReadOnly()) {
      <button iButton size="md" variant="secondary" [loading]="loading()" (click)="renewAccess()">
        <IIcon name="plug" />{{ label() }}
      </button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenewAdvertisingAccessButtonComponent {
  private readonly accountMarketplaceService = inject(AccountMarketplaceService);
  private readonly toasterService = inject(ToasterService);
  private readonly accountSelectionService = inject(AccountSelectionService);

  label = input.required<string>();

  private readonly accountMarketplace = toSignal(this.accountSelectionService.singleAccountMarketplaceSelection$, {
    requireSync: true,
  });

  protected readonly isReadOnly = computed(() => isReadOnlyAccess(this.accountMarketplace().accessLevel));
  protected readonly loading = signal(false);

  protected renewAccess(): void {
    const accountMarketplace = this.accountMarketplace();
    this.loading.set(true);
    this.accountMarketplaceService
      .addAmazonUser(accountMarketplace.resourceOrganizationId!, accountMarketplace)
      .pipe(
        take(1),
        finalize(() => this.loading.set(false)),
      )
      .subscribe({
        next: () => this.toasterService.success("Access successfully renewed", "Login with Amazon"),
        error: (errorMessage) => this.toasterService.error(errorMessage, "Login with Amazon error"),
      });
  }
}
